import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography, Link } from '@albo-ui/core';
import { chargebacksStatus, chargebacksType } from '../../../util/DataObject';
import { formatMoney } from '../../../util/Functions';
import moment from "moment";
moment.locale('es');

export type ChargebacksDialogProps = {
    data: any;
    open: boolean;
    title: string;
    props?: any;
    onClose: () => void;
} & DefaultComponentProps;

export const Chargebacks = ({ open, title, data, props, onClose }: ChargebacksDialogProps) => {

    return (
        <Dialog onClose={onClose} open={open}>
            <DialogTitle>
                <Typography variant='h2'>{title}</Typography>
            </DialogTitle>

            <DialogContent>
                <FlexGrid container direction='column' fullWidth style={{marginBlock: 15}}>
                {data && props.map((item) => {
                    return data.hasOwnProperty(item.key) &&
                        <FlexGrid container key={item.key} style={{paddingBlock: 3}}>
                            <Typography variant="paragraph" color="lightNeutral" style={{width: "35%", fontSize: 16, paddingRight: 25}}>{item.label}</Typography>
                            <Typography variant="paragraph" style={{width: "65%", fontSize: 16, overflowWrap: "anywhere"}}>
                                {
                                    item.type === "date" ? moment(data[item.key]).format("L") : 
                                    item.type === "amount" ? formatMoney(data[item.key]) : 
                                    item.type === "link" ? (data[item.key] ?
                                    <Link underlined bold style={{display: "flex", alignItems: "center", width: "55%"}} href={data[item.key]} >
                                        Ver documento
                                    </Link>
                                    : "No aplica" )
                                    : 
                                    item.type === "status" ? chargebacksStatus.map((s) => s.name === data[item.key] && s.title) : 
                                    item.type === "type" ? chargebacksType.map((s) => s.name === data[item.key] && s.title) : 
                                    data[item.key] || "No aplica"
                                }
                            </Typography>
                        </FlexGrid>
                })}
                </FlexGrid>
            </DialogContent>
        
            <DialogActions>
                <FlexGrid justify='flex-end'>
                    <Button onClick={onClose} size='normal'>Cerrar</Button>
                </FlexGrid>
            </DialogActions>
        </Dialog>
    )
}